// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingAcceptancePanel_root__fPBdI","form":"EditListingAcceptancePanel_form__36DNM","title":"EditListingAcceptancePanel_title__1jFkL"};